import { bindActionCreators } from 'redux'

export const Authenticated = 'Authenticated';
export const NotAuthenticated = 'NotAuthenticated';
export const UserAccsessList = 'UserAccsessList';
export const isAdmin = 'isAdmin';
export const isNotAdmin = 'isNotAdmin';


const setAuth = () =>({type: Authenticated})
const setAdmin = () =>({type: isAdmin})
const setNotAdmin = () =>({type: isNotAdmin})

const setUnAuth = () =>({type: NotAuthenticated})

const setAccessList = (list) =>({type: UserAccsessList, data: list})

export default function AuthActions(dispatch) {
    return bindActionCreators(
        { setAuth, setUnAuth, setAccessList, setAdmin, setNotAdmin}
        , dispatch)
}
